import { Action } from "~/modules/actions/Action";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { CbmImpl, PausedChannelsResponse } from "~/modules/cbm";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";


















export class GetPausedConversations implements Action<Promise<PausedChannelsResponse>> {
    


    #pageSize: number;

    constructor(pageSize: number = 60) {
        this.#pageSize = pageSize;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const worker = taskRouter.worker;

        try {
            const response = await cbm.getPausedChannels(this.#pageSize);
            sendTrackingEvent(EVENTS.GetPausedConversationsCompleted, analytics, worker, { pageSize: this.#pageSize });
            return response;
        } catch (error) {
            const errorMsg = `GetPausedConversations: Failed to get paused conversations: ${error}`;
            sendTrackingEvent(EVENTS.GetPausedConversationsCompleted, analytics, worker, {
                error: errorMsg,
                pageSize: this.#pageSize
            });
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
